export default "__VITE_ASSET__DJmrKaKD__"